import { billingConsoleService } from '../../services';

interface IConfig {
  getBillingConsoleReport: (params: any) => Promise<any>;
  getCsvBillingConsoleReport: (params: any) => Promise<any>;
}

export const config: IConfig = {
  getBillingConsoleReport: (params: any) =>
    billingConsoleService.getBillingConsoleReport(params),
  getCsvBillingConsoleReport: (params: any) =>
    billingConsoleService.getCsvBillingConsoleReport(params),
};

export const formatLabel = (label: string) => {
  return label
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
